export const FORM_LAYOUT = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};

export const onInputChange = ({ state, setState, form }) => {
  return (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setState({
      ...state,
      [name]: value,
    });
    if (form) {
      form.setFieldValue(name, value);
      form.validateFields([name]);
    }
  };
};
